module.exports = __webpack_public_path__ + "img/Selo-Maior-Satisfao.67598f29.svg";